import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Minus, Plus } from "lucide-react";

const clamp = (v, min, max) => Math.min(max, Math.max(min, v));

export const NumberStepper = ({ value, onChange, min = 1, max = 600, step = 1, decimals = 0, disabled, testId, className = "" }) => {
  const [text, setText] = useState(String(value));
  useEffect(() => { setText(String(value)); }, [value]);

  const round = (v) => Number(v.toFixed(decimals));
  const commit = (raw) => {
    const n = parseFloat(String(raw).replace(",", "."));
    const next = Number.isFinite(n) ? round(clamp(n, min, max)) : value;
    setText(String(next));
    if (next !== value) onChange(next);
  };
  const bump = (d) => commit(round((Number(value) || 0) + d * step));

  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid={testId}>
      <Button type="button" size="icon" variant="secondary" className="h-8 w-8" disabled={disabled || value <= min}
        onClick={() => bump(-1)} data-testid={`${testId}-minus`}><Minus className="h-3.5 w-3.5" /></Button>
      <div className="relative">
        <input type="text" inputMode="decimal" value={text} disabled={disabled}
          onChange={(e) => setText(e.target.value)} onBlur={(e) => commit(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && commit(e.currentTarget.value)}
          className="h-8 w-16 rounded-md border border-input bg-background pr-5 text-center font-mono-label text-sm text-primary disabled:opacity-50"
          data-testid={`${testId}-field`} />
        <span className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-xs text-muted-foreground">s</span>
      </div>
      <Button type="button" size="icon" variant="secondary" className="h-8 w-8" disabled={disabled || value >= max}
        onClick={() => bump(1)} data-testid={`${testId}-plus`}><Plus className="h-3.5 w-3.5" /></Button>
    </div>
  );
};
